module.exports = __webpack_public_path__ + "img/struc-timber-beam.b4efa970.jpg";